import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import QuoteStatusBadge from '../quote/status.component.jsx'
import Pagination from "../common/listing/pagination.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import OrderStatusBadge from "../order/status.component.jsx";
import NewOrderModal from "../order/NewOrderModal.tsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'
import GlobalHelper from '../common/GlobalHelper.jsx';
class OrderList extends Component {

    constructor(props, context) {
        super(props, context)

        const contactId = this.props.contactId || ''
        this.state = {
            contactId: contactId,
            defaultContactId: '',
            noEmployee: false,
            headers: [],
            rows: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            modal: '',
            accountLimit: null,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
        this.openCreationModal = this.openCreationModal.bind(this)
        this.closeCreationModal = this.closeCreationModal.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

        if (this.state.contactId) {
            this.loadOrdersByContactId(this.state.contactId)
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            contactId: nextProps.contactId
        }, () => {
            this.loadOrdersByContactId(this.state.contactId)
        })
    }

    headers() {
        return [
            <FormattedMessage
                id="customers.orders.list.headers.id_label"
                defaultMessage="ID"
            />,
            <FormattedMessage
                id="customers.orders.list.headers.value_label"
                defaultMessage="Total Amount"
            />,
            <FormattedMessage
                id="customers.orders.list.headers.order_date_label"
                defaultMessage="Order date"
            />,
            <FormattedMessage
                id="customers.quotes.list.headers.status_label"
                defaultMessage="Status"
            />,
        ]
    }

    row(order) {
        return [
            <span>
                <Link to={'/orders/' + order.id + '/edit'}>
                    {order.identifier}
                </Link>
                <small className={"ml-2"}>{order.poNumber}</small>
            </span>,
            <FormattedNumber
                style="currency"
                currency={order.currency}
                value={order.totalAmount}
            />,
            <span> {order.orderedAt ? <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(order.orderedAt)} /> :
                "-"}
            </span>,
            <OrderStatusBadge statusId={order.customStatusId} key={order.id} />,
        ]
    }

    loadOrdersByContactId(contactId) {
        AppContext.getApiClient().get('/contacts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            this.setState({
                noEmployee: res.type === 'organizations' && !res.attributes.primaryContactId,
                defaultContactId: res.type === 'organizations' ? res.attributes.primaryContactId : res.id,
            })
            let postData = {
                keywords: '*',
                objects: ['orders'],
                fields: ['identifier', 'contact.name'],
                pageSize: this.state.pageSize,
                activePage: this.state.activePage,
                sortByField: 'createdAt',
                sortAsc: false,
                filters: {
                    contactId: res.attributes.customerAccountIds
                },
                lightResult: true,
            }
            return AppContext.getApiClient().post('/listing/search', postData)
        }).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }
    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.loadOrdersByContactId(this.state.contactId)
        })
    }

    openCreationModal(event) {
        event.preventDefault()
        this.setState({
            modal: <NewOrderModal
                contactId={this.state.defaultContactId}
                onClose={this.closeCreationModal}
            />
        })
    }

    closeCreationModal(orderId) {
        this.setState({
            modal: orderId ? <Redirect to={'/orders/' + orderId + '/edit'} /> : ''
        })
    }


    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                {this.state.modal}
                <StandardList
                    className="row pt-0"
                    smallLine={true}
                    headers={this.state.headers}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        {!this.state.noEmployee && this.state.accountLimit ? <div>
                            <ButtonWrapper
                                message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                    <FormattedMessage
                                        id="listing.search.invoice_document_limit"
                                        defaultMessage="Documents limit exceeded."
                                    /> : ''}
                                onClick={this.openCreationModal}
                                className={"btn btn-primary btn-sm"}
                                protectedClassName={"btn btn-primary btn-sm"}
                                premium={false}
                                protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)}>
                                <Icon value={'plus-circle'} className={'mr-1'} />
                                <FormattedMessage
                                    id="customers.orders.list.new_order_btn"
                                    defaultMessage="Create a new order"
                                />
                            </ButtonWrapper>

                        </div> : null}
                    </div>}
                />
            </div>

        );
    }
}

export default OrderList





// WEBPACK FOOTER //
// ./src/customer/orderlist.component.jsx